import { useEffect, useState } from "react";
import operatorApiService from "../../../../services/operator-api.service";
import LayoutEditModal from "../modal/LayoutEditModal";
import editIcon from "../../../../assets/imgs/master/edit_icon_wh.svg";

interface FourVehicleLayoutProps {
  baseId: number | null;
}

interface LayoutItem {
  layout_id: number;
  vehicle_id: number;
  vehicle_label: string;
}

interface VideoSetting {
  monitor_console_id: number;
  monitor_console_no: string;
  layout: LayoutItem[];
}

const FourVehicleLayout = ({ baseId }: FourVehicleLayoutProps) => {
  const [videoSettings, setVideoSettings] = useState<VideoSetting[]>([]);
  const [selectedConsole, setSelectedConsole] = useState<VideoSetting | null>(
    null
  );
  const [modalLayout, setModalLayout] = useState<(number | null)[]>([
    null,
    null,
    null,
    null,
  ]);

  const fetchData = async () => {
    if (!baseId) return;

    const settings = await operatorApiService.doGetFourVehicleLayout({
      baseId,
    });
    setVideoSettings(settings);
  };

  useEffect(() => {
    fetchData();
  }, [baseId]);

  const handleOpenEdit = async (monitorConsole: VideoSetting) => {
    const layout: (number | null)[] = [null, null, null, null];
    monitorConsole.layout.forEach((item) => {
      layout[item.layout_id - 1] = item.vehicle_id;
    });

    setModalLayout(layout);
    setSelectedConsole(monitorConsole);
  };

  const handleSave = () => {
    fetchData();
    setSelectedConsole(null);
  };

  return (
    <div className="section">
      <div className="sectionTitle">4車両映像設定</div>
      <div className="sectionBody">
        <div className="cardGrid">
          {videoSettings.map((s) => (
            <div className="cardArea" key={s.monitor_console_no}>
              <div className="cardTitle">監視卓 {s.monitor_console_no}</div>
              <div className="cardBody">
                <div className="vehicleGroup">
                  {s.layout.map((v: LayoutItem, idx: number) => (
                    <div className="vehicleName" key={idx}>
                      {v.vehicle_label}
                    </div>
                  ))}
                </div>
                <button
                  className="updateButton"
                  onClick={() => handleOpenEdit(s)}
                >
                  <img src={editIcon} alt="" className="icon" />
                  編集
                </button>
              </div>
            </div>
          ))}
        </div>

        {selectedConsole && baseId && (
          <LayoutEditModal
            isOpen={true}
            onClose={handleSave}
            monitorConsoleNo={selectedConsole.monitor_console_no}
            baseId={baseId}
            initialLayout={modalLayout}
          />
        )}
      </div>
    </div>
  );
};

export default FourVehicleLayout;
